var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1100_16203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92773 1.84961L21.5952 21.517",
    stroke: "#E94B52",
    strokeWidth: 2.69725,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5952 1.84961L1.92773 21.517",
    stroke: "#E94B52",
    strokeWidth: 2.69725,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1100_16203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4771,
    height: 22.4771,
    fill: "white",
    transform: "translate(0.522949 0.444824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross_red.37eb6af9e7d34b3fa2dfd95cef1d444a.svg";
export { ForwardRef as ReactComponent };